<div class="image-container">
  <img class="image-size" src="assets/themes/{{ themeService.currentLogo }}" alt="Company logo">
</div>
